import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name ProLayout 默认设置
 * @description 配置 ProLayout 的全局默认属性
 * @doc https://procomponents.ant.design/components/layout
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Skeleton Admin',
  pwa: true,
  logo: 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg',
  iconfontUrl: '',
  token: {},
};

export default Settings;
